<template>
  <button
    type="button"
    class="seat-color flex max-w-[40px] shrink-0 items-center justify-center rounded border duration-100"
    :class="[
      size === 'md' ? 'aspect-square w-auto' : 'h-5 w-5',
      {
        'active:shadow-md': !(isAisle || isBusy || disabled),
      },
    ]"
    :disabled="isBusy || disabled"
    :style="seatColor"
  >
    <img
      v-if="isBusy && !isAisle"
      src="@/assets/images/seat-busy-icon.svg"
      height="15"
      width="15"
      alt="место занято"
    />
    <p
      v-else
      class="text-[2vw]"
      :class="{
        'text-text-neutral-secondary': isAisle,
        'text-static-white': isSelected,
      }"
    >
      {{ seatText }}
    </p>
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import type { SerializedSeat } from '../lib';
  import type { SeatColors } from '../types';

  const props = withDefaults(
    defineProps<{
      size?: 'sm' | 'md';
      isSelected?: boolean;
      seat: SerializedSeat;
      seatColors: SeatColors | null;
      disabled?: boolean;
    }>(),
    {
      size: 'md',
      seatColors: null,
    },
  );

  const isBusy = computed(() => !(props.seat.available && props.seat.exists));
  const isAisle = computed(() => props.seat.type === 'aisle');
  const seatColor = computed(() => {
    if (isAisle.value) {
      return {
        '--seat-bg-color': 'transparent',
        '--seat-border-color': 'transparent',
      };
    }
    if (isBusy.value) {
      return {
        '--seat-bg-color': '#EAECED',
        '--seat-border-color': '#EAECED',
      };
    }
    if (props.seatColors) {
      return props.isSelected
        ? {
            '--seat-bg-color': props.seatColors.selected,
            '--seat-border-color': props.seatColors.selected,
          }
        : {
            '--seat-bg-color': props.seatColors.base,
            '--seat-border-color': props.seatColors.base,
          };
    }
    if (props.isSelected) {
      return {
        '--seat-bg-color': '#4EBC73',
        '--seat-border-color': '#4EBC73',
      };
    }
    return null;
  });
  const seatText = computed(() => {
    if (isAisle.value) {
      return props.seat.coordinates.row;
    }
    if (props.isSelected) {
      return `${props.seat.key}`;
    }
    return '';
  });
</script>

<style scoped>
  .seat-color {
    --seat-bg-color: transparent;
    --seat-border-color: theme('colors.gray.400');
    background-color: var(--seat-bg-color);
    border-color: var(--seat-border-color);
  }
</style>
